module.exports = __webpack_public_path__ + "static/media/share-square.432a7005.svg";